import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const QrMultiSelect = props => {
  const { label, options, value, onChange } = props;

  const classes = useStyles();

  const anchorRef = useRef(null);

  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const handleOptionToggle = event => {
    let newValue = [...value];

    const eValue = JSON.parse(event.target.value);
    if (event.target.checked) {
      newValue.push(eValue);
    } else {
      newValue = newValue.filter(item => item.id !== eValue.id);
    }
    onChange && onChange(newValue);
  };

  return (
    <Fragment>
      <Button
        className={classes.botton}
        fullWidth
        onClick={handleMenuOpen}
        ref={anchorRef}
        variant="outlined"
      >
        {label}
        <div className={classes.flexGrow} />
        <ArrowDropDownIcon />
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        className={classes.menu}
        onClose={handleMenuClose}
        open={openMenu}
        // eslint-disable-next-line react/jsx-sort-props
        PaperProps={{ style: { width: 250 } }}
      >
        {options.map((option, index) => {
          return (
            <MenuItem
              className={classes.menuItem}
              key={option.id}
            >
              <FormControlLabel
                className={classes.formControlLabel}
                control={
                  <Checkbox
                    checked={value.findIndex(qr => qr.id === option.id) > -1}
                    color="primary"
                    onClick={handleOptionToggle}
                    value={JSON.stringify(option)}
                  />
                }
                label={option.qrName}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </Fragment>
  );
};

QrMultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired
};

export default QrMultiSelect;

const useStyles = makeStyles(theme => ({
  root: {},
  botton: {
    paddingTop: 7.5,
    paddingBottom: 7.5,
    paddingLeft: 14,
    paddingRight: 0,
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 'normal',
    lineHeight: '1.1875em',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  flexGrow: {
    flexGrow: 1
  },
  menuItem: {
    padding: 0
  },
  formControlLabel: {
    padding: theme.spacing(0.5, 2),
    width: '100%',
    margin: 0
  }
}));
